<template>
    <div>
        <section class="signup_area">

            <div class="container">
                <div class="row">
                    <div class="col-lg-12">

                        <div class="form-container d-flex">
                            <div class="form-wrap">
                                <div class="cardify signup_form">
                                    <div class="login--header">
                                        <h3>Зарегистрируйте ваш аккаунт</h3>
                                        <p>Пожалуйста, заполните следующие поля, чтобы зарегистрироваться. </p>
                                    </div>
                                    <!-- end .login_header -->

                                    <div class="alert alert-danger" v-if="errors">
                                        <ul v-for="errorMsgs in errors">
                                            <li class="text-center" v-for="errorMsg in errorMsgs" v-html="errorMsg"></li>
                                        </ul>
                                    </div>

                                    <div class="login--form">

                                        <div class="form-group">
                                            <label for="phone">Ваш телефон:</label>
                                            <input id="phone" type="tel" class="form-control" v-model="$v.formData.phone.$model" autocomplete="off" v-mask="'+375 (##) ###-##-##'" placeholder="+375 (29) 111-11-11">
                                            <div class="field-error-text" v-if="$v.formData.phone.$error">Неверный номер телефона!</div>
                                            <div class="field-error-text" v-if="smsNotSend">Не удалось отправить SMS. Попробуйте указать другой номер.</div>
                                        </div>
                                        <div class="form-group" v-if="showSmsCodeField">
                                            <label for="smsCodeField">Введите код, отправленный на Ваш телефон:</label>
                                            <input id="smsCodeField" type="text" v-model="$v.formData.sms_code.$model" class="form-control">
                                            <div class="field-error-text" v-if="smsCodeIsInvalid">Неверный код подтверждения!</div>
                                        </div>
                                        <button v-if="showSendSmsBtn" :disabled="$v.formData.phone.$invalid" class="btn btn--md btn--round register_btn" @click="sendPhoneVerifySms">Отправить смс</button>
                                        <button v-if="showSendToVerifySmsBtn" :disabled="$v.formData.sms_code.$invalid" class="btn btn--md btn--round register_btn" @click="sendSmsCodeToVerify">Отправить</button>
                                        <template v-if="isPhoneApproved">
                                            <div class="form-group">
                                                <label for="name">Ваши имя и фамилия</label>
                                                <input id="name" v-model="$v.formData.name.$model" type="text" class="form-control">
                                                <div class="field-error-text" v-if="$v.formData.name.$error">Поле имеет неверное значение</div>
                                            </div>

                                            <div class="form-group">
                                                <label for="email_ad">Email адрес</label>
                                                <input id="email_ad" v-model="$v.formData.email.$model" type="email" class="form-control">
                                                <div class="field-error-text" v-if="$v.formData.email.$error">Поле имеет неверное значение</div>
                                            </div>

                                            <div class="form-group">
                                                <label for="password">Пароль</label>
                                                <input id="password" type="password" v-model="$v.formData.password.$model" class="form-control">
                                                <div class="field-error-text" v-if="$v.formData.password.$error">Поле имеет неверное значение</div>
                                            </div>

                                            <div class="form-group">
                                                <label for="password_confirmation">Подтверждение пароля</label>
                                                <input id="password_confirmation" type="password" v-model="$v.formData.password_confirmation.$model" class="form-control">
                                                <div class="field-error-text" v-if="$v.formData.password_confirmation.$error">Поле имеет неверное значение</div>
                                                <div class="field-error-text" v-if="!$v.formData.password_confirmation.confirm">Пароли не совпадают</div>
                                            </div>

                                            <div class="custom-radio">
                                                <input type="radio" id="roleVolunteer" v-model="$v.formData.role.$model" class="" value="volunteer" name="role" checked>
                                                <label for="roleVolunteer">
                                                    <span class="circle"></span>Индивидуальный волонтер
                                                </label>
                                            </div>
                                            <div class="custom-radio">
                                                <input type="radio" id="roleZooOrgOwner" v-model="$v.formData.role.$model" class="" value="zooprotection_org_owner" name="role">
                                                <label for="roleZooOrgOwner">
                                                    <span class="circle"></span>Благотворительная организация
                                                </label>
                                            </div>
                                            <div class="custom-radio">
                                                <input type="radio" id="roleDonatorBasic" v-model="$v.formData.role.$model" class="" value="donator_basic" name="role">
                                                <label for="roleDonatorBasic">
                                                    <span class="circle"></span>Даритель
                                                </label>
                                            </div>

                                            <div class="field-error-text" v-if="$v.formData.role.$error">Выберите, пожалуйста, тип аккаунта</div>


                                            <button class="btn btn--md btn--round register_btn" @click="register" :disabled="$v.formData.$invalid">Зарегистрироваться</button>
                                        </template>
                                        <div class="login_assist">
                                            <p>Уже есть аккаунт? <a href="/auth/login">Войти</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
    import {mapMutations} from 'vuex';
    import {mask} from 'vue-the-mask'
    import {helpers, required, minLength, maxLength, sameAs, between, email, requiredIf} from 'vuelidate/lib/validators';

    const phoneValidator = helpers.regex('phone', /^\+375\s\((29|44|33|25)\)\s[1-9]{1}\d{2}-\d{2}-\d{2}$/g)

    export default {
        directives: {mask},
        props: ['data'],
        components: {},
        data() {
            return {
                errors: null,
                appRoutes: null,
                phoneChangeControl: null,
                formData: {
                    phone_stripped: null,
                    phone: null,
                    sms_code: null,
                    name: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                    role: null,

                    organizationID: null,
                    entry_token: null,

                },
                isPhoneApproved: false,
                showSmsCodeField: false, // Поле для ввода кода из смс
                showSendSmsBtn: true, // Кнопка отправки смс кода
                showSendToVerifySmsBtn: false, // Кнопка отправки кода, для проверки
                smsCodeIsInvalid: false, // Кнопка отправки кода, для проверки
                smsNotSend: false
            }
        },
        created() {
            this.appRoutes = window.appRoutes;
        },

        mounted() {

            if (this.data) {
                this.formData.organizationID = this.data.organization && this.data.organization.id ? this.data.organization.id : null

                try {

                    const queryString = window.location.search;

                    const urlParams = queryString.length ? new URLSearchParams(queryString) : null;

                    this.formData.entry_token = urlParams.has('entry_token') ? urlParams.get('entry_token') : null;

                } catch (error) {
                    console.log(error)
                }

            }

        },

        methods: {
            sendPhoneVerifySms() {
                let self = this;

                axios.post('/' + this.appRoutes['auth.sendPhoneVerifySms'], {phone: this.formData.phone, phone_stripped: this.formData.phone_stripped})
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            self.smsNotSend = false;
                            self.smsCodeIsInvalid = false;
                            self.showSmsCodeField = true;
                            self.showSendSmsBtn = false;
                            self.showSendToVerifySmsBtn = true;
                        } else {
                            self.smsNotSend = true;
                        }
                    })
                    .catch((error) => {
                        console.log(error.response.data.errors);
                        self.errors = error.response.data.errors;
                    })
                    .then();
            },
            sendSmsCodeToVerify() {
                let self = this;
                axios.post('/' + this.appRoutes['auth.checkSmsCode'], {phone: this.formData.phone, code: this.formData.sms_code})
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            self.showSmsCodeField = false;
                            self.showSendSmsBtn = false;
                            self.showSendToVerifySmsBtn = false;
                            self.isPhoneApproved = true;
                            self.smsCodeIsInvalid = false;
                        } else {
                            self.smsCodeIsInvalid = true;
                        }
                    })
                    .catch((error) => {

                    })
                    .then();
            },
            register() {
                let self = this,
                    params = {
                        phone_stripped: this.formData.phone_stripped,
                        phone: this.formData.phone,
                        sms_code: this.formData.sms_code,
                        name: this.formData.name,
                        email: this.formData.email,
                        password: this.formData.password,
                        password_confirmation: this.formData.password_confirmation,
                        role: !this.formData.organizationID ? this.formData.role : null,

                        organization_id: this.formData.organizationID ? this.formData.organizationID : null,
                        entry_token: this.formData.entry_token ? this.formData.entry_token : null,
                    };

                axios.post('/auth/register', params)
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            this.setComponent('profile-component')
                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                'event': 'registration'
                            });

                            window.location.href = response.redirectUrl;


                        } else {
                            alert('УПС!');
                        }
                    })
                    .catch((error) => {

                    })
                    .then();
            },

            ...mapMutations({
                setComponent: 'setterProfileTab',
            }),


        },
        watch: {
            formData: {
                handler(val, oldVal) {
                    this.phoneChangeControl = val.phone;
                },
                deep: true
            },
            phoneChangeControl() {
                let self = this;
                self.isPhoneApproved = false;
                self.showSendSmsBtn = true;
                self.formData.sms_code = null;
                self.formData.phone_stripped = self.formData.phone.replace(/(\s|-|\(|\))/gm, '');
            }

        },
        validations: {
            // name: {
            //     required,
            //     minLength: minLength(4)
            // },
            formData: {
                phone: {
                    required,
                    phoneValidator
                },
                sms_code: {
                    required
                },
                name: {
                    required,
                    maxLength: 100
                },
                email: {
                    required,
                    email
                },
                password: {
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(30),
                },
                password_confirmation: {
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(30),
                    confirm(value) {
                        return value === this.formData.password;
                    }
                },
                role: {
                    required: requiredIf(function () {
                        if (this.formData.organizationID) {
                            return false
                        }
                        ;

                        return true;

                    })
                }
            }

        },

    }
</script>
